import React, { useEffect, useState } from 'react';
import * as Styled from './InformationServiceModal.styles';
import { useSelector } from 'react-redux';
import { getCookie, setCookie } from '@/utils/cookies.helper';
import { RichTextRender } from '../RichTextRender/RichTextRender';
import { fetchInformationService } from '@/services/search';

const COOKIE_PREFIX = 'flapper-information-service';
const COOKIE_EXPIRY_HOURS = 8;

export const InformationServiceModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const currentLanguage = useSelector(state => state.general.language);
  const [currentInfo, setCurrentInfo] = useState(null);
  const parsedLocale = currentLanguage.replace('_', '-');

  function handleClose() {
    setIsOpen(false);
    const date = new Date();
    date.setTime(date.getTime() + COOKIE_EXPIRY_HOURS * 60 * 60 * 1000);

    setCookie(
      `${COOKIE_PREFIX}-${parsedLocale}-${currentInfo?.documentId}`,
      true,
      {
        expires: date,
      }
    );
  }

  async function getInformationService() {
    try {
      const { data = [] } = await fetchInformationService(currentLanguage);

      if (data && data?.length > 0) {
        // pega o primeiro que não foi fechado ainda
        const nextInfo = data.find(info => {
          const cookieName = `${COOKIE_PREFIX}-${parsedLocale}-${info?.documentId}`;
          return !getCookie(cookieName);
        });

        if (nextInfo) {
          setCurrentInfo(nextInfo);
          setIsOpen(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getInformationService();
  }, [currentLanguage]);

  if (!isOpen || !currentInfo) return null;

  return (
    <Styled.ModalOverlay>
      <Styled.ModalContent>
        <Styled.ModalHeader>
          <Styled.ModalHeaderTitle>{currentInfo?.title}</Styled.ModalHeaderTitle>
          <Styled.CloseButton onClick={handleClose}>×</Styled.CloseButton>
        </Styled.ModalHeader>
        <Styled.Message>
          <RichTextRender content={currentInfo?.text} />
        </Styled.Message>
      </Styled.ModalContent>
    </Styled.ModalOverlay>
  );
};
